import axios from 'axios';

// API Base URL - same as admin site
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/ykrestapi';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Latest Events API (Public - no authentication required)
export const latestEventsAPI = {
  // Get all active events for a specific site
  getAll: async (siteName = 'yugalkunj') => {
    try {
      console.log('🌐 API Call: GET /api/latest-events with siteName:', siteName);
      const response = await api.get('/api/latest-events', {
        params: { siteName }
      });
      console.log('📡 Raw API Response:', response);
      console.log('📦 Response Data:', response.data);
      console.log('🔍 Response Status:', response.status);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching latest events:', error);
      console.error('Error response:', error.response);
      return { success: false, events: [], message: error.message };
    }
  },

  // Get event by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/api/latest-events/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching event:', error);
      return { success: false, event: null, message: error.message };
    }
  },
};

// Words of Wisdom API (Public - no authentication required)
// Uses the main COREAPI instance: GET /ykrestapi/api/words-of-wisdom
export const wordsOfWisdomAPI = {
  // Get all active Words of Wisdom entries
  getAll: async () => {
    try {
      const response = await api.get('/api/words-of-wisdom');
      return response.data;
    } catch (error) {
      console.error('Error fetching Words of Wisdom:', error);
      return { success: false, data: [], message: error.message };
    }
  },

  // Get single Words of Wisdom entry by ID (includes full HTML body)
  getById: async (id) => {
    try {
      const response = await api.get(`/api/words-of-wisdom/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching Words of Wisdom detail:', error);
      return { success: false, data: null, message: error.message };
    }
  },
};

export default api;
